import Vue from 'vue';
import LocalesComponent from "../components/LocalesComponent";
import SidenavComponent from "../components/SidenavComponent";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import QuotesComponent from "../components/QuotesComponent";
import AppBarComponent from "../components/AppBarComponent";
import TipsComponent from "@/components/TipsComponent";
import AlertComponent from "@/components/AlertComponent";
import LoadingPageComponent from "@/components/LoadingPageComponent";
import {TiptapVuetify} from "tiptap-vuetify";

Vue.component('locales-component', LocalesComponent);
Vue.component('sidenav-component', SidenavComponent);
Vue.component('validation-observer', ValidationObserver);
Vue.component('validation-provider', ValidationProvider);
Vue.component('quotes-component', QuotesComponent);
Vue.component('tip-component', TipsComponent);
Vue.component('app-bar-component', AppBarComponent);
Vue.component('alert-component', AlertComponent);
Vue.component('loading-page-component', LoadingPageComponent)
Vue.component('tiptap-vuetify', TiptapVuetify)
